import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IState {
	selectedRow?: string
}

const initialState = {
	selectedRow: undefined,
}

export const customerEmissionRequestSlice = createSlice({
	name: 'customerEmissionRequest',
	initialState,
	reducers: {
		setSelectedRow: (
			state: IState,
			action: PayloadAction<string | undefined>
		) => {
			state.selectedRow = action.payload
		},
	},
})

export const { setSelectedRow } = customerEmissionRequestSlice.actions

export default customerEmissionRequestSlice.reducer
